import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Top from "../components/Top";
import Navbar from "../components/Navbar";

const EditUser = ({ currentUser }) => {
    const [loading, setLoading] = useState(false);
    let { id, name, email, role } = useParams()
    const [nName, setNName] = useState(name)
    const [nEmail, setNEmail] = useState(email)
    const [nRole, setNRole] = useState(role)


    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [serverError, setServerError] = useState("");
    const navigate = useNavigate();

    const onSubmit = async (data) => {
        setServerError("");
        try {
            setLoading((prev) => !prev)
            const payload = {
                name: data.name || nName,
                email: data.email || nEmail,
                role: data.role || nRole,
                password: data.password,
                id: id,
                prevEmail: email
            };

            await axios.post(
                `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/user/edit`,
                payload,
                { withCredentials: true }
            );

            toast.success("Edited Successfully")
            setLoading((prev) => !prev)
            navigate("/users");
        } catch (error) {
            setLoading(false)
            if (error.response && error.response.data) {
                toast.error(error.response.data.message)
            }
        }
    };
    return (
        <div className="py-6 px-3 xl:px-8 sm:px-5">
            <Top currentUser={currentUser} />
            <Navbar currentUser={currentUser} />
            <div className="bg-white rounded-lg px-0 xl:px-8 sm:px-6 p-8 mt-0 w-full sm:w-[450px] xl:w-[520px] mx-auto">
                <h2 className=" font-semibold text-[24px] sm:text-[28px] xl:text-[32px] 2xl:text-[36px] xxl:text-4xl leading-none tracking-normal text-[#5D0E23]">
                    Edit User
                </h2>

                <form
                    className="mt-2 sm:mt-3 2xl:mt-4 flex flex-col gap-2"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <div className="mb-2">
                        <input
                            defaultValue={name}
                            type="text"
                            id="name"
                            {...register("name", {
                                maxLength: {
                                    value: 56,
                                    message: "Name cannot exceed 56 characters"
                                }
                            })}
                            className={`text-[12px] sm:text-[14px] xl:text-[16px] appearance-none border border-[#797979] rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.name ? "border-red-500" : ""
                                }`}
                            placeholder={name}
                        />
                        {errors.name && (
                            <p className="text-red-500 text-xs italic">
                                {errors.name.message}
                            </p>
                        )}
                    </div>

                    <div className="mb-2">
                        <input
                            autoComplete="new-password"
                            defaultValue={email}
                            type="email"
                            id="email"
                            {...register("email")}
                            className={`text-[12px] sm:text-[14px] xl:text-[16px] appearance-none border border-[#797979] text-[#47474A] rounded w-full py-3 px-5 leading-tight focus:outline-none  ${errors.email ? "border-red-500" : ""
                                }`}
                            placeholder={email}
                        />
                        {errors.email && (
                            <p className="text-red-500 text-xs italic">
                                {errors.email.message}
                            </p>
                        )}
                    </div>

                    <div className="mb-2 text-[#47474A]">
                        <select
                            id="role"
                            {...register("role")}
                            className={`text-[12px] sm:text-[14px] xl:text-[16px] appearance-none border border-[#797979] text-[#47474A] rounded w-full py-3 px-5 leading-tight focus:outline-none  ${errors.role ? "border-red-500" : ""
                                }`}
                        >
                            <option className="text-[#47474A]" value="" disabled selected>
                                Select role
                            </option>
                            <option selected={role === "admin"} value="admin">Admin</option>
                            <option selected={role === "recruiter"} value="recruiter">Recruiter</option>
                        </select>
                        {errors.role && (
                            <p className="text-red-500 text-xs italic">
                                {errors.role.message}
                            </p>
                        )}
                    </div>

                    <div className="mb-0">
                        <input
                            autoComplete="new-password"
                            type="password"
                            id="password"
                            {...register("password", {
                                pattern: {
                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
                                    message:
                                        "Password must be 8+ characters with 1 uppercase, 1 lowercase, 1 number, and 1 special character",
                                },
                            })}
                            className={` text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.password ? "border-red-500" : ""
                                }`}
                            placeholder="Set Password"
                        />
                        {errors.password && (
                            <p className="text-red-500 text-xs italic">
                                {errors.password.message}
                            </p>
                        )}
                    </div>

                    <div className="flex items-center justify-center">
                        <button
                            type="submit"
                            className="cursor-pointer  font-semibold text-[20px] xl:text-[18px] rounded-[6px] xl:rounded-[6px] mt-5 2xl:mt-6 xxl:mt-7 2xl:rounded-[8px] xxl:rounded-[10px] 2xl:text-[20px] xxl:text-2xl leading-none tracking-normal bg-[#7F132F] w-[55%] hover:bg-[#55051A] text-white py-3 focus:outline-none "
                        >
                            {loading ? <ClipLoader size={"1em"} color="white" /> : "Edit User"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditUser;
